'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var events = require('events');
var reactUtils = require('@sravni/react-utils');
var Notifications_types = require('../types/Notifications.types.js');

class NotificationManager extends events.EventEmitter {
    notifications = [];
    constructor() {
        super();
    }
    create({ type = 'info', title, subtitle, message, timeout, closable }) {
        const opts = {
            id: reactUtils.getUuid(),
            type,
            title,
            subtitle,
            message,
            closable,
        };
        this.notifications.unshift(opts);
        this.emitChange();
        setTimeout(() => {
            this.remove(opts.id);
        }, timeout);
    }
    show(props) {
        const { timeout = Notifications_types.NOTIFICATION_TIMEOUT, type = Notifications_types.NOTIFICATION_STATUSES.INFO, closable = true, ...restProps } = props;
        this.create({ timeout, type, closable, ...restProps });
    }
    remove(id) {
        this.notifications = this.notifications.filter((n) => id !== n.id);
        this.emitChange();
    }
    emitChange() {
        this.emit('change', [...this.notifications]);
    }
    addChangeListener(callback) {
        this.addListener('change', callback);
    }
    removeChangeListener(callback) {
        this.removeListener('change', callback);
    }
}
var NotificationManager$1 = new NotificationManager();

exports.default = NotificationManager$1;
//# sourceMappingURL=NotificationManager.js.map
